// ABOUTME: SPEC-82 D-11 — the two facts the bottom band's consumers need (is the revealed row open, are the
// ABOUTME: flanks hidden), as a tiny external store: they sit deep in the Projectionist with no prop path.

import { useSyncExternalStore } from 'react';
import { CONTROLS_LIFT, REVEAL } from '../components/VoiceFirst/VoiceDock/voiceDockTokens';

// Idiom: state/transcriptStore.js. The DEFAULT is "today": a consumer that computes from it gets
// exactly the number it computed before the experiment existed, so a flag-off tenant never moves.
// `tweenMs` is 0 unless the dock publishes a reveal, so a flag-off consumer adds no `transition`.
const DEFAULT = Object.freeze({ controlsOpen: false, flanksHidden: false, tweenMs: 0 });
let state = DEFAULT;
const listeners = new Set();

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Merge a patch; a patch that changes nothing emits nothing (no needless re-render of ten consumers). */
export function setBottomChrome(patch) {
  const next = { ...state, ...patch };
  if (Object.keys(next).every((k) => next[k] === state[k])) return;
  state = Object.freeze(next);
  listeners.forEach((l) => l());
}

export function resetBottomChrome() {
  setBottomChrome(DEFAULT);
}

/** Imperative read (tests, non-React callers). */
export const getBottomChrome = () => state;

/** @param {(s: typeof DEFAULT) => *} selector must return a primitive so Object.is can bail out */
export function useBottomChrome(selector) {
  return useSyncExternalStore(subscribe, () => selector(state));
}

/**
 * The lift a bottom-band consumer adds to its own `bottom`/ceiling, in `composition`'s authored units:
 * 0 while the row is closed (so flag-off is arithmetic-identical), CONTROLS_LIFT while it is open.
 */
export function useControlsLift(composition) {
  return useBottomChrome((s) => (s.controlsOpen ? CONTROLS_LIFT[composition] : 0));
}

/** `transition` for a lifted property, in step with the row's own tween; `undefined` when no reveal exists. */
export function useLiftTransition(property) {
  const ms = useBottomChrome((s) => s.tweenMs);
  return ms ? `${property} ${ms}ms ${REVEAL.easing}` : undefined;
}
